<template>
  <SFaq />
</template>

<script lang="ts">
import { getMetaInfo } from '@/utils/seo';

export default {
  name: 'FaqPage',
  metaInfo() {
    return getMetaInfo((this as { pageData?: { Seo?: unknown } }).pageData?.Seo);
  },
};
</script>

<script setup lang="ts">
import { SFaq } from '@slg/web-customer-shared';
</script>

<style lang="scss" scoped>
</style>
